import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Sobre Nosotros',
    href: '#nosotros'
  }, {
    name: 'Especialidades',
    href: '#especialidades'
  }, {
    name: 'Espacios',
    href: '#espacios'
  }, {
    name: 'La Carta',
    href: '#carta'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-laura-dark/95 backdrop-blur-sm py-3 shadow-lg' : 'bg-transparent py-5'}`} data-id="element-263">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-264">
        <div className="flex justify-between items-center" data-id="element-265">
          <a href="#inicio" className="text-xl md:text-2xl font-playfair font-bold text-laura-cream tracking-wide" data-id="element-266">
            El Rincón de Laura
          </a>

          <div className="hidden lg:flex items-center space-x-6" data-id="element-267">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-laura-cream/90 hover:text-laura-olive transition-colors text-sm uppercase tracking-wider" data-id="element-268">
                {link.name}
              </a>)}
            <a href="https://wa.me/34660343711" target="_blank" rel="noopener noreferrer" className="bg-laura-amber text-laura-dark px-5 py-2 rounded font-bold uppercase tracking-wider text-sm hover:bg-laura-gold transition-colors" data-id="element-269">
              Reservar
            </a>
          </div>

          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden text-laura-cream hover:text-laura-olive transition-colors" aria-label="Toggle menu" data-id="element-270">
            {isMobileMenuOpen ? <XIcon size={28} data-id="element-271" /> : <MenuIcon size={28} data-id="element-272" />}
          </button>
        </div>
      </div>

      <div className={`lg:hidden absolute top-full left-0 w-full bg-laura-dark border-t border-laura-wood/50 transition-all duration-300 ease-in-out ${isMobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible h-0'}`} data-id="element-273">
        <div className="px-4 pt-2 pb-6 space-y-3 flex flex-col" data-id="element-274">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block text-laura-cream hover:text-laura-olive py-3 text-base uppercase tracking-wider border-b border-laura-wood/30" data-id="element-275">
              {link.name}
            </a>)}
          <a href="https://wa.me/34660343711" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)} className="inline-block text-center bg-laura-amber text-laura-dark px-6 py-3 mt-4 rounded font-bold uppercase tracking-wider hover:bg-laura-gold transition-colors" data-id="element-276">
            Reservar
          </a>
        </div>
      </div>
    </nav>;
}